"use strict";

// ============================================
// テーブルの添付ファイルの有無でrowspanをつける
// ============================================
function createTable() {
  const table = document.querySelector(".js-table");
  const rows = table.querySelectorAll(".js-file");

  const firstEl = rows[0].querySelector(".js-hasFile");
  if (firstEl) {
    firstEl.classList.remove("js-hasFile");
  }

  let num = 0;
  let arr = [];

  rows.forEach((row) => {
    const hasFile = row.querySelector(".js-hasFile");
    const noFile = row.querySelector(".js-empty");

    if (hasFile) {
      arr.push(num);
      num = 0;
      return;
    }

    if (noFile) {
      num++;
      noFile.remove();
      return;
    }
  });

  arr.push(num);

  const targets = table.querySelectorAll(".js-addRowspan");
  for (let i = 0; i < targets.length; i++) {
    if (arr[i] !== 0) {
      targets[i].rowSpan = arr[i] + 1;

      if (targets[targets.length - 1]) {
        targets[targets.length - 1].dataset.number = "last";
      }
    }
  }
}

export { createTable };
